import { Button, TextInput } from "risa-oasis-ui_v2";
import { DetailsCard } from "../../../components/detailsCard/detailsCard";
import { DetailsCardItem, VisibilityState } from "../types/credentialTypes";

interface CredentialDetailsPanelProps {
  detailsCardData: DetailsCardItem[];
  passwordState: VisibilityState;
  secretKeyState: VisibilityState;
  hasCredentialId: boolean;
  hasSecretKey: boolean;
  onTogglePassword: () => void;
  onToggleSecretKey: () => void;
  portalName?: string;
  username?: string;
  onEditClick?: () => void;
}

export const CredentialDetailsPanel = ({
  detailsCardData,
  passwordState,
  secretKeyState,
  hasCredentialId,
  hasSecretKey,
  onTogglePassword,
  onToggleSecretKey,
  portalName,
  username,
  onEditClick,
}: CredentialDetailsPanelProps) => {
  const showHeader = !!portalName || !!username;

  return (
    <div className="flex h-full flex-col">
      {showHeader && (
        <div className="mb-2 flex items-center justify-between gap-2 pl-2">
          <div className="flex min-w-0 items-baseline gap-2">
            {portalName && (
              <div
                className="truncate text-sm font-semibold"
                title={portalName}
              >
                {portalName}
              </div>
            )}
            {username && (
              <div
                className="truncate text-xs text-primaryGray-4"
                title={username}
              >
                {username}
              </div>
            )}
          </div>
          {onEditClick && (
            <button
              type="button"
              onClick={onEditClick}
              className="shrink-0 cursor-pointer rounded p-1 text-xs font-semibold text-[#0056D6] transition-opacity hover:opacity-70"
            >
              Edit Credential
            </button>
          )}
        </div>
      )}
      <div className="flex h-auto flex-1 flex-col overflow-auto">
        <div className="rounded bg-gray-100 text-xl">
          <DetailsCard
            details={detailsCardData}
            elementsInOneRow={2}
            showBorder={true}
          />
        </div>

        <div className="credential-details-password-container mt-2 flex w-full flex-row items-end gap-3 py-3">
          <div className="w-1/2 items-center gap-2">
            <TextInput
              label="Password"
              defaultValue={
                passwordState.isVisible
                  ? passwordState.value
                  : "••••••••••••••••"
              }
              id="password"
              readOnly={true}
            />
          </div>

          <Button
            buttonType="primary"
            size="medium"
            disabled={passwordState.isLoading || !hasCredentialId}
            onClick={onTogglePassword}
          >
            {passwordState.isLoading
              ? "Loading..."
              : passwordState.isVisible
                ? "Hide Password"
                : "Show Password"}
          </Button>
        </div>
        {hasSecretKey && (
          <div className="credential-details-password-container mt-2 flex w-full flex-row items-end gap-3 py-3">
            <div className="w-1/2 items-center gap-2">
              <TextInput
                label="Secret Key"
                defaultValue={
                  secretKeyState.isVisible
                    ? secretKeyState.value
                    : "••••••••••••••••"
                }
                id="secret-key"
                readOnly={true}
              />
            </div>

            <Button
              buttonType="primary"
              size="medium"
              disabled={secretKeyState.isLoading}
              onClick={onToggleSecretKey}
            >
              {secretKeyState.isLoading
                ? "Loading..."
                : secretKeyState.isVisible
                  ? "Hide Secret Key"
                  : "Show Secret Key"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
